import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getProjectStatusColorVariantPipe',
  standalone: true,
})
export class GetProjectStatusColorVariantPipe implements PipeTransform {
  transform(statusId: number | null | undefined): 'neutral' | 'success' | 'warning' | 'error' | 'empty' {
    switch (statusId) {
      case 4:
      case 28:
      case 39:
        return 'warning';
      case 5:
      case 6:
      case 7:
        return 'success';
      default:
        return 'neutral';
    }
  }
}
